import ToolTip from 'components/tooltip';
import IconButton from 'components/controls/buttons/icon-button';
import OAIcon from 'assets/icons/open-access.svg';
import styles from './open-access-info.module.scss';

const descriptionText = `
#####Open Access
As part of the Met's [Open Access policy](/about-the-met/policies-and-documents/open-access), you can freely copy, modify and distribute this image, even for commercial purposes.

#####API
Public domain data for this object can also be accessed using the Met's [Open Access API](https://metmuseum.github.io/).`;

const OpenAccessToolTip = () => {
	return (
		<ToolTip description={descriptionText} id="OpenAccess">
			<IconButton
				label="Public Domain"
				className={styles.button}
				lightMode={true}
				small={true}
				showLabel={true}
				icon={<OAIcon />}
			/>
		</ToolTip>
	);
};

export default OpenAccessToolTip;
